// Dashboards hub entry for X-One Exposure · Findings (/exposure/findings;
// was /dashboards/vulnerabilities/findings until MP900), the remediation
// workbench, so it can be found and pinned on its own.
export const dashboardEntry = {
  key: 'vulnerability-findings',
  title: 'Vulnerability findings',
  description: 'Work through every open vulnerability: risk, SLA status and owners, with filters and bulk actions.',
  route: '/exposure/findings',
  icon: 'clipboard-check',
  // The page belongs to X-One Exposure; every row is a Posture scanner result.
  app: 'exposure',
  apps: ['posture'],
  adminOnly: true,
  flag: 'app.exposure',
} as const;
